import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { type ReactNode } from 'react';
import { Button, Dialog, Modal as AriaModal, ModalOverlay } from 'react-aria-components';
import { MdClose } from 'react-icons/md';
import styles from './modal.module.scss';
interface ModalProps {
  children: ReactNode;
  isCloseOnClickOutside?: boolean;
  showCloseIcon?: boolean;
  isOpen?: boolean;
  defaultOpen?: boolean;
  fullSize?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  positionMobile?: 'top';
}
export default function Modal(props) {
  const $ = _c(17);
  const {
    children,
    defaultOpen: t0,
    fullSize: t1,
    isCloseOnClickOutside: t2,
    isOpen,
    onOpenChange,
    positionMobile,
    showCloseIcon: t3
  } = props;
  const defaultOpen = t0 === undefined ? false : t0;
  const fullSize = t1 === undefined ? false : t1;
  const isCloseOnClickOutside = t2 === undefined ? false : t2;
  const showCloseIcon = t3 === undefined ? false : t3;
  const t4 = positionMobile === "top" && styles.modal_overlay__positionMobileTop;
  let t5;
  if ($[0] !== t4) {
    t5 = cx(styles.modal_overlay, t4);
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = fullSize && styles.modal_content__fullSize;
  let t7;
  if ($[2] !== t6) {
    t7 = cx(styles.modal_content, t6);
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== showCloseIcon) {
    t8 = showCloseIcon && <Button slot="close" className={styles.modal_closeButton}><MdClose className={styles.modal_closeIcon} /></Button>;
    $[4] = showCloseIcon;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== children || $[7] !== t7 || $[8] !== t8) {
    t9 = <AriaModal className={styles.modal_aria} isKeyboardDismissDisabled={true}><Dialog className={styles.modal_dialog}><div className={t7}>{t8}{children}</div></Dialog></AriaModal>;
    $[6] = children;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== defaultOpen || $[11] !== isCloseOnClickOutside || $[12] !== isOpen || $[13] !== onOpenChange || $[14] !== t5 || $[15] !== t9) {
    t10 = <ModalOverlay className={t5} defaultOpen={defaultOpen} onOpenChange={onOpenChange} isOpen={isOpen} isDismissable={isCloseOnClickOutside}>{t9}</ModalOverlay>;
    $[10] = defaultOpen;
    $[11] = isCloseOnClickOutside;
    $[12] = isOpen;
    $[13] = onOpenChange;
    $[14] = t5;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}